import { MantineProvider } from "@mantine/core";
import ReactDOM from "react-dom/client";
import "@mantine/core/styles.css";
import "./assets/css/index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MantineProvider theme={{ fontFamily: "Lexend, sans-serif" }}>
    <App />
  </MantineProvider>,
);
